<template>
	<div>
		<div class="aboutus">

			<div class="aboutus-item" >
				<div class="aboutitem-hea">
					<span class="aboutitem-hea-text" @click="productto(0)">
						{{product_centet}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in categorylist" >
						<span class="aboutitem-fooitem-text" @click="productto(item.id)">
							{{item.name}}
						</span>
					</div>
					<div class="aboutitem-fooitem" >
						<span class="aboutitem-fooitem-text" @click="productto(0)">
							<span>More</span> <i class="el-icon-arrow-right"></i>
						</span>
					</div>
				</div>
			</div>
<!--			<div class="aboutus-item" >-->
<!--				<div class="aboutitem-hea">-->
<!--					<span class="aboutitem-hea-text" @click="video_to(0)">-->
<!--						{{video_centet.title}}-->
<!--					</span>-->
<!--				</div>-->
<!--				<div class="aboutitem-foo">-->
<!--					<div class="aboutitem-fooitem" v-for="(item,index) in video_centet.list" >-->
<!--						<span class="aboutitem-fooitem-text" @click="video_to(index)">-->
<!--							{{item.name}}-->
<!--						</span>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
			<div class="aboutus-item" >
				<div class="aboutitem-hea">
					<span class="aboutitem-hea-text">
						{{academy.title}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in academy.list" >
						<span class="aboutitem-fooitem-text" @click="academy_to(index)">
							{{item.name}}
						</span>
					</div>
				</div>
			</div>



			<div class="aboutus-item" >

				<div class="aboutitem-hea">
						<span @click="queryto(-1)" class="aboutitem-hea-text">
							{{contact_us.title}}
						</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in contact_us.list" >
						<span class="aboutitem-fooitem-text" @click="queryto(index)">
							{{item.name}}
						</span>
					</div>
				</div>

				<div class="aboutitem-hea">
					<span @click="toNews" class="aboutitem-hea-text">
						News
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" >
						<span class="aboutitem-fooitem-text" @click="toNews">
							News
						</span>
					</div>
				</div>
			</div>

			<div class="aboutus-item">
				<div class="aboutitem-hea">
					<span class="aboutitem-hea-text" @click="contactusto(0)">
						{{follow_us.title}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in follow_us.list"  >
						<span class="aboutitem-fooitem-text" @click="contactusto(item.id)">
							{{item.name}}
						</span>
					</div>
				</div>

				<div class="aboutitem-hea">
					<span class="aboutitem-hea-text" @click="aboutto(0)">
						{{about_us.title}}
					</span>
				</div>
				<div class="aboutitem-foo">
					<div class="aboutitem-fooitem" v-for="(item,index) in about_us.list" >
						<span @click="aboutto(index)" class="aboutitem-fooitem-text">
							{{item.name}}
						</span>
					</div>
				</div>
			</div>
			<!--  -->
			<!-- <div class="aboutus-item"></div>
			<div class="aboutus-item"></div>
			<div class="aboutus-item"></div>
			<div class="aboutus-item"></div> -->
			<div class="aboutus-item">
				<div class="aboutitem-hea" v-if="$store.state.lang == 'cn'">
					<div class="contact_box">
						<ul class="phone_num">
							<li class="contact_box_title"><span >服务热线<img src="../assets/pchomeimg/foot_icon/电话.png" alt=""></span></li>
							<li><span>销售部:</span>{{phone_num.sale}}</li>
							<li><span>市场部:</span>{{phone_num.market}}</li>
							<li><span>人力资源部:</span>{{phone_num.humen_resources}}</li>
							<li><span>客户服务部:</span>{{phone_num.customer_service}}</li>
						</ul>
					</div>
					<div class="contact_box">
						<ul class="code_icon">
							<li class="contact_box_title"><span >关注啄木鸟<img src="../assets/pchomeimg/foot_icon/关注.png" alt=""></span></li>
							<li v-for="(item,index) in icon_data" :key="index" class="icon_list">
								<img class="icon" :src="show_code == item.name?item.img_hover:item.img" alt=""
								  @mouseenter="icon_hover(item.name)" @mouseleave="icon_leave">
								<div class="QR_code" :style="show_code == item.name?'opacity:1':'opacity:0'">
									<div class="background"></div>
									<img :src="item.QR_code" alt="">
									<div class="QR_title">{{item.text}}</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<div class="aboutitem-hea" v-if="$store.state.lang == 'en'">
					<div class="contact_box_en">
						<ul class="phone_num">
							<li class="contact_box_title"><span >Sales Dept<img src="../assets/pchomeimg/foot_icon/电话.png" alt=""></span></li>
							<li><span>+86-773-5873196</span></li>
						</ul>
					</div>
					<div class="contact_box_en">
						<ul class="code_icon">
							<li class="contact_box_title"><span >E-Mail<img src="../assets/pchomeimg/foot_icon/邮箱.png" alt=""></span></li>
							<li><span>woodpecker4@glwoodpecker.com</span></li>
						</ul>
					</div>
					<div class="contact_box_en">
						<ul class="code_icon">
							<li class="contact_box_title"><span >Public Page<img src="../assets/pchomeimg/foot_icon/关注.png" alt=""></span></li>
							<li v-for="(item,index) in icon_data_en" :key="index" class="icon_list">
								<img class="icon" :src="show_code == item.name?item.img_hover:item.img" alt=""
								  @mouseenter="icon_hover(item.name)" @mouseleave="icon_leave" @click="new_page(item.src)">
								  <div class="lang_text">{{item.text}}</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="homefoot">
			<div class="foot-hea" @click="toBeiAn" >
				Copyright @2014 Guilin Woodpecker Medical Instrument Co.,Ltd. All right reserved. 桂ICP备11001158号-1
			</div>
			<div class="foot-f">
				Qualification Certificate for Drug Information Services over the Internet (桂)-Non Profit-2018-0004
			</div>
		</div>

	</div>

</template>

<script>
	import 'lib-flexible/flexible.js'
	import {session} from '../storage/storage.js';
	export default{
		data(){
			return{
				show_code:'',
				icon_data:[
					{	
						name:'gong_zhong_hao',
						img:require('../assets/pchomeimg/foot_icon/公众号.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/公众号_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/公众号二维码.png'),
						text:'公众号:啄木鸟医疗'
					},
					{	
						name:'shi_ping_hao',
						img:require('../assets/pchomeimg/foot_icon/视频号.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/视频号_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/视频号二维码.png'),
						text:'视频号:啄木鸟医疗'
					},
					{	
						name:'xiao_cheng_xu',
						img:require('../assets/pchomeimg/foot_icon/小程序.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/小程序_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微信小程序二维码.png'),
						text:'小程序:啄木鸟医疗'
					},
					{	
						name:'wei_bo',
						img:require('../assets/pchomeimg/foot_icon/微博.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/微博_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微博二维码.png'),
						text:'微博:啄木鸟医疗'
					},
					{	
						name:'wei_xin',
						img:require('../assets/pchomeimg/foot_icon/微信支付.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/微信支付_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/微信商城二维码.png'),
						text:'商城:啄木鸟配件'
					},
					{	
						name:'WEndo',
						img:require('../assets/pchomeimg/foot_icon/WEendo.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/WEendo_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/WEndo根管公众号二维码.png'),
						text:'公众号:啄木鸟医疗WE根管'
					},
					{	
						name:'tao_bao',
						img:require('../assets/pchomeimg/foot_icon/淘宝.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/淘宝_点击.png'),
						QR_code:require('../assets/pchomeimg/foot_icon/淘宝商城二维码.png'),
						text:'淘宝:啄木鸟医疗'
					}
				],
				icon_data_en:[
					{	
						name:'ins_en',
						img:require('../assets/pchomeimg/foot_icon/ins.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/ins_点击.png'),
						src:'https://www.instagram.com/woodpeckermedical/?hl=zh-cn',
						text:'EN'
					},
					{	
						name:'fb_en',
						img:require('../assets/pchomeimg/foot_icon/FB.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/FB_点击.png'),
						src:'https://www.facebook.com/WoodpeckerDentalChina',
						text:'EN'
					},
					{	
						name:'fb_es',
						img:require('../assets/pchomeimg/foot_icon/FB.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/FB_点击.png'),
						src:'https://www.facebook.com/WoodpeckerDentalLatino',
						text:'ES'
					},
					{	
						name:'ins_ar',
						img:require('../assets/pchomeimg/foot_icon/ins.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/ins_点击.png'),
						src:'https://instagram.com/woodpecker_arabic?utm_medium=copy_link',
						text:'AR'
					},
					{	
						name:'fb_ar',
						img:require('../assets/pchomeimg/foot_icon/FB.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/FB_点击.png'),
						src:'https://www.facebook.com/Woodpecker-Arabic-العربية-106744631679097',
						text:'AR'
					},
					{	
						name:'Youtube',
						img:require('../assets/pchomeimg/foot_icon/Youtube.png'),
						img_hover:require('../assets/pchomeimg/foot_icon/Youtube_点击.png'),
						src:'https://www.youtube.com/channel/UCQR0nx9QqXtsYIidyxYSwxw',
						text:''
					}
				],
				phone_num:{
					sale:'0773-5831172/5835305',
					market:'0773-2350521',
					humen_resources:'0773-2350520',
					customer_service:'0773-5827898/13978361362'
				},
				categorylist:'',
				channel_data:'',
				product_centet:"产品中心",
				about_us:{
					'title':"关于我们",
					'list' :[
						{'name':"公司简介",'id':1},
						{'name':"公司历史",'id':2},
						{'name':"公司活动相册",'id':3},
						{'name':"公司荣誉",'id':4}
					]
				},
				video_centet:{
					title:'视频中心',
					list:[
						{'name':"产品介绍",'id':1},
						{'name':"案例分析",'id':2},
						{'name':"网络课程",'id':3},
					]
				},
				academy:{
					title:'Academy',
					list:[
						{name:'Courses',id:1},
						{name:'Videos',id:2},
					]
				},
				contact_us:{
					'title':"联系我们",
					'list' :[
						{'name':"维护保养",'id':1},
						{'name':"经销商登入",'id':2},
						// {'name':"产品视频",'id':3},
						{'name':"下载专区",'id':3}
					]
				},
				follow_us:{
					'title':"关注我们",
					'list' :[
						{'name':"在线留言",'id':2},
						{'name':"百度地图",'id':1},
					]
				},
				info:{
					'title1':"电话查询",
					'sale':"销售部",
					'marcket':'市场部',
					'humen_resources':"人力资源部",
					'customer_service':"客户服务部",
					'title2':"关注啄木鸟",
				},

			}
		},
		created() {
			this.get_index_channel_data()
			this.get_channel_product_catrgory()
			this.pageParam()
		},
		methods:{
			new_page(src){
				if(src){
					window.open(src)
				}
			},
			icon_hover(item){
				this.show_code = item
			},
			icon_leave(){
				this.show_code = ''
			},
			get_channel_product_catrgory(){
				let data={
					lang:session.get('lang'),
					channel_id: session.get('channel_id'),
					  // page:1,
					  pageSize:11,
				}
				this.$api.get_channel_category_list(data).then((res) => {
					this.categorylist=res.data
				});
			},
			scrollIntoView(id){
				this.$nextTick(function () {
						var dom = document.getElementById(id)
								if(dom != null){
								dom.scrollIntoView()
							}
					})
			},
			get_index_channel_data(){
				return
				let data= {
					mold: "pc",
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
				};
				this.$api.get_channel_index(data).then((res) => {
					console.log('res.datafoot')
					this.channel_data =  res.data;
				});
			},
			toNews(){
				this.$router.push({ path: "/pc-news" });
			},
			queryto(index) {
			  	this.$router.push({ path: "/pcquerys?e="+(index*1+1) });
			},
			academy_to(index){
				index ? this.$router.push({ path: "/pc-academy-videos" }) : this.$router.push({ path: "/pccourses" })
			},
			video_to(index){
				this.$router.push({ path: "/pcvideos?e="+index });
				// if( this.$route.path == '/pcvideos'){
				// 	this.$router.go(0)
				// }
			},
			productto(e) {
				this.$router.push({ path: "/pcproduct?e="+e });
				// if( this.$route.path == '/pcproduct'){
				// 	this.$router.go(0)
				// }
			},
			contactusto(e) {
			  this.$router.push({ path: "/pccontactus?e="+e});
			},
			aboutto(e) {
			  this.$router.push({ path: "/pcabout?e="+(e*1+1) });
			},
			pageParam(){
				this.get_channel_product_catrgory();
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.product_centet = "产品中心",
					this.about_us = {
						'title':"关于我们",
						'list' :[
							{'name':"公司简介",'id':1},
							{'name':"公司历史",'id':2},
							{'name':"公司活动相册",'id':3},
							{'name':"公司荣誉",'id':4}
						]
					},
					this.video_centet={
						title:'视频中心',
						list:[
							{'name':"产品介绍",'id':1},
							{'name':"案例分析",'id':2},
							{'name':"网络课程",'id':3},
						]
					},
					this.contact_us ={
						'title':"用户服务",
						'list' :[
							{'name':"防伪鉴别",'id':1},
							{'name':"维护保养",'id':2},
							{'name':"资料下载",'id':3},
							{'name':"常见问题",'id':4}
						]
					},
					
					this.follow_us = {
						'title':"联系我们",
						'list' :[
							{'name':"在线留言",'id':1},
							{'name':"百度地图",'id':2},
						]
					},
					this.info ={
						'title1':"电话查询",
						'sale':"销售部",
						'marcket':'市场部',
						'humen_resources':"人力资源部",
						'customer_service':"客户服务部",
						'title2':"关注啄木鸟",
					}
				}else{
					this.product_centet = "PRODUCTS",
							this.about_us = {
								'title':"ABOUT US",
								'list' :[
									{'name':"About Woodpecker",'id':1},
									{'name':"Company Corner",'id':2},
									{'name':"Honors",'id':3},
									// {'name':"News",'id':4}
								]
							},
							this.contact_us ={
								'title':"USERS SERVICE",
								'list' :[
									{'name':"Anti-Fake Inquiry",'get_product_detailid':1},
									{'name':"Maintenance",'id':2},
									// {'name':"Download",'id':3},
									{'name':"FAQ",'id':3}]
							},
							this.video_centet={
								title:'VIDEOS',
								list:[
									{'name':"Product Introduction",'id':1},
									{'name':"Case Sharing",'id':2},
									{'name':"Webinar",'id':3},
								]
							},
							this.follow_us = {
								'title':"CONTACT US",
								'list' :[
									{'name':"Online Message",'id':2},
									{'name':"Map",'id':1},
									{'name':"Join Us",'id':3},
								]
							},
							this.info={
								'title1':"电话查询",
								'sale':"销售部",
								'marcket':'市场部',
								'humen_resources':"人力资源部",
								'customer_service':"客户服务部",
								'title2':"关注啄木鸟",
							}
				}
			},
			toBeiAn(){
				window.location.href = 'https://beian.miit.gov.cn'
			},
		}
	}
</script>
<style scoped>
li{
	list-style: none;
	position: relative;

}
ul{
	padding:0;
	cursor: auto;
}
.icon{
	width: 30px;
	height: 30px;
}
.icon_list{
	margin-right: 10px;
	position: relative;
	cursor: pointer;
}

.lang_text{
	width: 30px;
	font-size: 12px;
	color: #CCCCCC;
	position: absolute;
	text-align: center;
	left: 0;
	top: 28px;
}
.aboutitem_section{
	position: absolute;
	right: 240px;
}
</style>
<style>
.QR_code{
	width: 172px;
	height: 200px;
	position: absolute;
	left: -70px;
    top: -215px;
	transition: all 0.5s;
}
.QR_title{
	width: 172px;
	position: absolute;
    bottom: 0;
    text-align: center;
	font-size: 12px;
    color: #8a8f99;
}
.QR_code::after {
    content: '';
    position: absolute;
    top: -webkit-calc(100% - 1px);
    top: -moz-calc(100% - 1px);
    top: calc(100% - 1px);
    left: 50%;
    margin-left: -10px;
    width: 18px;
    height: 11px;
	background-image:url(../assets/pchomeimg/foot_icon/down.svg);
    background-size: 100% 100%;
}
.background{
	width: 172px;
	height: 200px;
	background-color: #FFFFFF;
	position: absolute;
	left: 0;
	top: 0;
	z-index: -0.5;
}
.QR_code img{
	width: 172px;
	height: 172px;
	position: absolute;
}
.contact_box{
	margin-left: 25px;
	font-size: 14px;
	padding-top: 0px;
	/* padding-left: 100px; */
}
.contact_box_en{
	/* margin-left: 1570px; */
	font-size: 14px;
	padding-top: 0px;
	/* padding-left: 100px; */
}
.contact_box_title{
	color: #CCCCCC;
	margin-bottom: 5px;
}
.contact_box_title span{
	position: relative;
}
.contact_box_title img{
	width: 20px;
	height: 20px;
	position: absolute;
	left:-25px;
	top: 0;
}
.code_icon .contact_box_title{
	display: block;
}
.code_icon li{
	display: inline-block;
}
.code_icon span{
	margin-right: 10px;
}


	.aboutus{
		display: flex;
		padding-left: 260px;
		box-sizing: border-box;
		/*height: 670px;*/
		background: #272727;
		/* margin-top: 80px; */
	}
	.aboutus-item{
		/* margin-left: 55px !important; */
		/*    flex: 1;*/
		width: 222px;
		margin-left: 65px;
	}
	.aboutus-item:first-child{
		margin-left: 0px !important;
	}
	.aboutus-item:last-child {
		width: 280px;
	}
	.aboutitem-hea{
		margin-top: 80px;
		margin-bottom: 40px;
		height: 33px;
		font-size: 20px!important;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 33px;
		letter-spacing: 1px;
	}
	.aboutitem-hea-text {
		cursor: pointer;
	}
	.aboutitem-foo{
		/*height: 22px;*/
		font-size: 14px;
		font-weight: 400;
		color: #CCCCCC;
		line-height: 22px;
	}
	.aboutitem-fooitem{
		margin-bottom: 10px;
		width: 210px;
		overflow:hidden;
		text-overflow:ellipsis;
		white-space:nowrap;
	}
	.aboutitem-fooitem-text {
		cursor: pointer;
		display: flex;
	}
	.aboutitem-fooitem-text i {
		font-size: 12px;
		padding-left: 5px;
		padding-top: 5px;
		display: block;
	}

	.fooitem-left{
		width: 110px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #EAEAEA;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-weight: 400;
		color: #FAFAFA;
		margin-right: 20px;
	}
	.fooitem-left img{
		width: 16px;
		height: 16px;
		margin-right: 6px;
	}
	.aboutitem-foosus{
		display: flex;
		margin-bottom: 20px;
	}
	.fooitem-right{
		font-size: 16px;
		font-weight: 400;
		color: #CCCCCC;
	}
	.fooitem-cont{
		margin-top: 25px;
		margin-left: 40px;
	}
	.fooitem-cont:first-child{
		margin-left: 0px;
	}
	.fooite-img{
		display: flex;
	}
	.fooite-img img{
		width: 90px;
		height: 90px;
	}
	.fooite-nam{
		text-align: center;
		margin-top: 20px;
	}
	.right-tit{
		margin-bottom: 5px;
	}
	.homefoot{
		
		background: #272727;
		border-top: 2px solid #666;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.foot-hea{
		margin-top: 18px;
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		cursor: pointer;
	}
	.foot-f{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
	}
</style>
